<template>
  <router-view />
</template>

<script>
import Vue from 'vue'

export default {
  name: 'App',
  metaInfo () {
    return {
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places`,
          async: true,
          defer: true,
          callback: () => this.onGooglePlacesLoad()
        }
      ]
    }
  },
  methods: {
    onGooglePlacesLoad () {
      Vue.prototype.$geocoder = new window.google.maps.Geocoder();
      Vue.prototype.$autocomplete = new window.google.maps.places.AutocompleteService()
    }
  },
}
</script>
